// extracted by mini-css-extract-plugin
export default {"scroll-loader":"style_scroll-loader__Rcuti__WHx6O","is-popup":"style_is-popup__pCRv2__WHx6O"};